import { render, staticRenderFns } from "./InlineTableView.vue?vue&type=template&id=00967683&scoped=true&"
import script from "./InlineTableView.vue?vue&type=script&lang=js&"
export * from "./InlineTableView.vue?vue&type=script&lang=js&"
import style0 from "./InlineTableView.vue?vue&type=style&index=0&id=00967683&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00967683",
  null
  
)

export default component.exports